import React from 'react';
import Box from "./Class/Box";
import Api from "./Api/Api";
import {Route, Switch} from "react-router";
import {BrowserRouter as Router, Redirect} from 'react-router-dom'
import LoadingSpinner from "./Components/parts/LoadingSpinner";
import {ErrorContext} from "./Context/ErrorContext";
import AppHeader from "./Components/parts/AppHeader";
import PiattiList from "./Components/page-parts/PiattiList";
import ConfirmModal from "./Components/parts/ConfirmModal";
import Carrello from "./Components/page-parts/Carrello";
import OrdinaMobileButton from "./Components/parts/OrdinaMobileButton";
import OrdineFormModal from "./Components/ModalContent/OrdineFormModal";
import ls from "local-storage"

class App extends React.Component{
  constructor(props) {
    super(props);
    this.state = {piatti: [], categorie: [], config: [], liste: [], fasceOrarie: [], piattiFiltrati: [],
        currentList: 0, loading: true, currentCategoria: null, currentError: null,
        currentModalError: null, isList: false, redirect: null, confirmModal: false, domicilio: false, orderModal: false, modalLoading: false};
  }

  componentDidMount() {
      this.retrieveData();
  }


  retrieveData(){
    const piattiProm = Api.getPiatti();
    const categorieProm = Api.getCategorie();
    const impostazioniProm = Api.getImpostazioni();
    const fasceProm = Api.getFasceOrarie();
    Promise.all([piattiProm, categorieProm, impostazioniProm, fasceProm])
        .then((res) => {
          let piatti = res[0];
          let impostazioni = res[2];
          let fasceOrarie = res[3];

          let currentCategoria = {id: "0", nome: "Tutti i piatti"};
          let categorie = [currentCategoria, ...res[1]];
          // // set the default filter
          // if(categorie.length){
          //     currentCategoria = categorie[0];
          // }

          let currentList = new Box(1000);
          if(ls.get('liste')) {
              let prev = ls.get('liste')[0];
              if (prev.nElementi > 0) {
                  currentList.nElementi = prev.nElementi;
                  currentList.totPrezzo = prev.totPrezzo;
                  currentList.max = prev.max;
                  currentList.piatti = prev.piatti;
              }
          }
          let liste = [currentList];

          // Enable domicilio if asporto is not available
          let domicilio = !impostazioni['asporto'];

          // set the new values
          this.setState({piatti: piatti, categorie: categorie, config: impostazioni, fasceOrarie: fasceOrarie, loading: false,
              currentCategoria: currentCategoria, domicilio: domicilio, liste: liste});
          this.filterPiatti(currentCategoria, piatti, true);
        })
        .catch((err) => {
          this.setState({loading: false});
          this.setError(err);
        });
  }

  openConfirmModal = () => {
      this.setState({confirmModal: true});
      setTimeout(this.closeConfirmModal, 1000);
  }

  closeConfirmModal = () => {
      this.setState({confirmModal: false});
  }

  setDomicilio = (val) => {
      this.setState({domicilio: val});
  }

  addToList = (piatto, lista, qta, inCarrello) => {
      let l = [...this.state.liste];
      l[lista].addPiatto(piatto, qta);
      this.setState({liste: l});
      ls.set("liste", l);
      // open confirm dialog
      if(!inCarrello)
        this.openConfirmModal();
  }

  removeToList = (piatto, lista, qta) => {
      let l = [...this.state.liste];
      l[lista].removePiatto(piatto, qta);
      this.setState({liste: l});
      ls.set("liste", l);
  }

  deleteFromList = (piatto, lista) => {
      let l = [...this.state.liste];
      l[lista].deletePiatto(piatto);
      this.setState({liste: l});
      ls.set("liste", l);
  }

  openOrderModal = () => {
      this.setState({orderModal: true});
  }

  closeOrderModal = () => {
      this.setState({orderModal: false});
  }

  orderConfirm = (ordine) => {
      let count = ordine.count ? ordine.count : 0;
      console.log(count);
      this.setState({modalLoading: true});
      this.unsetError();
      let dettagliOrdine = {contenuto: this.state.liste[0], domicilio: this.state.domicilio ? 1 : 0, ...ordine};
      Api.inviaOrdine(dettagliOrdine)
          .then((res) => {
              let currentList = new Box(1000);
              this.setState({liste: [currentList], modalLoading: false, orderModal: false});
              ls.set("liste", [currentList]);
              window.location.href = res.redirect;
          })
          .catch((err) => {
              if(err && err.status ===  503 && err.token && count < 3){
                  // security trick for rate limiting
                  setTimeout(() => this.orderConfirm({...ordine, token: err.token, count: (count+1)}), 2000);
              }else{
                  this.setError(err, "modal");
                  this.setState({modalLoading: false});
              }
          })
  }

  setIsList = (value) => {
      this.setState({isLista: value});
  }

  setCurrentCategoria = (categoria) => {
      let cat = this.state.categorie.find((c) => {
          return c.id === categoria;
      });
      if(cat){
          this.setState({currentCategoria: cat});
          this.filterPiatti(cat, this.state.piatti);
      }
  }

  // Filtra la lista dei piatti secondo la categoria specificata
  filterPiatti = (categoria, listapiatti, firstFilter) => {
      if(firstFilter && (this.state.currentCategoria && this.state.currentCategoria.id !== categoria.id)){
          return;
      }

      if(categoria.id === "0"){
          this.setState({piattiFiltrati: this.state.piatti})
      }else {
          let piattiFiltrati = listapiatti.filter((p) => {
              return p.categoria === categoria.id;
          });
          this.setState({piattiFiltrati: piattiFiltrati});
      }
  }

  // Empty all the states containing errors
  unsetError = () => {
    this.setState({currentError: null, currentModalError: null});
  }

  // Put the error inside state in order to be shown
  // if err has not an attribute msg, a default value is provided
  // "where" is used in order to put the error inside the modal or in the main page
  setError = (err, where) => {
    let error = {};
    if(err && this.state.user && err.status === 401){
      // user authentication expired
      error.msg = "Effettua il login";
      this.setState({user: null});
    }else{
      if(!err.msg){
        // if there isn't any error message provide a default message
        error = {msg: "Impossibile completare l'operazione."};
      }else{
        error = err;
      }
    }

    if(where === "modal"){
      this.setState({currentModalError: error});
    }else{
      this.setState({currentError: error});
    }

  }

  render() {
      if(this.state.loading){
          return <LoadingSpinner />;
      } else {
          return <AppContainer piatti={this.state.piatti}
                               categorie={this.state.categorie}
                               config={this.state.config}
                               fasceOrarie={this.state.fasceOrarie}
                               currentList={this.state.currentList}
                               liste={this.state.liste}
                               currentCategoria={this.state.currentCategoria}
                               loading={this.state.loading}
                               currentError={this.state.currentError}
                               currentModalError={this.state.currentModalError}
                               isList={this.state.isList}
                               piattiFiltrati={this.state.piattiFiltrati}
                               confirmModal={this.state.confirmModal}
                               domicilio={this.state.domicilio}
                               orderModal={this.state.orderModal}
                               modalLoading={this.state.modalLoading}
                               closeConfirmModal={this.closeConfirmModal}
                               setCurrentCategoria={this.setCurrentCategoria}
                               setError={this.setError}
                               unsetError={this.unsetError}
                               addToList={this.addToList}
                               removeToList={this.removeToList}
                               deleteFromList={this.deleteFromList}
                               orderConfirm={this.orderConfirm}
                               setIsLista={this.setIsList}
                               setDomicilio={this.setDomicilio}
                               openOrderModal={this.openOrderModal}
                               closeOrderModal={this.closeOrderModal}

          />;
      }
  }
}

function AppContainer(props){
    let errorMessage = {
        error: props.currentError,
        modalError: props.currentModalError,
        setError: props.setError,
        unsetError: props.unsetError
    }
    return <ErrorContext.Provider value={errorMessage}>
        <Router>
            <Switch>
                <Route exact path={`${process.env.PUBLIC_URL}/categoria/:id/:nome`}render={({match}) =>
                    <>
                        <AppHeader categorie={props.categorie}
                                   currentCategoria={props.currentCategoria}
                                   isList={props.isList}
                                   currentList={props.currentList}
                                   liste={props.liste}
                                   setCurrentCategoria={props.setCurrentCategoria}/>
                        <PiattiList categorie={props.categorie}
                                    currentCategoria={props.currentCategoria}
                                    currentCategoriaInLink={match.params.id}
                                    currentList={props.currentList}
                                    addToList={props.addToList}
                                    setCurrentCategoria={props.setCurrentCategoria}
                                    piattiFiltrati={props.piattiFiltrati}
                                    />
                        <OrdinaMobileButton isList={false}
                                            liste={props.liste}/>
                    </>

                }/>
                <Route path={`${process.env.PUBLIC_URL}/riepilogo-ordine`}>
                    <AppHeader categorie={props.categorie}
                               currentCategoria={props.currentCategoria}
                               currentList={props.currentList}
                               liste={props.liste}
                               setCurrentCategoria={props.setCurrentCategoria}
                               isList={true}/>
                    <Carrello addToList={props.addToList}
                              removeToList={props.removeToList}
                              deleteFromList={props.deleteFromList}
                              liste={props.liste}
                              config={props.config}
                              domicilio={props.domicilio}
                              setDomicilio={props.setDomicilio}
                              openOrderModal={props.openOrderModal}/>
                    <OrdinaMobileButton isList={true}
                                        openOrderModal={props.openOrderModal}
                                        config={props.config}
                                        liste={props.liste}/>
                </Route>
                <Route path={"/"}>
                    {props.currentCategoria && <Redirect to={`${process.env.PUBLIC_URL}/categoria/${props.currentCategoria.id}/${encodeURI(props.currentCategoria.nome)}`}/>}
                    {!props.currentCategoria && <Redirect to={`${process.env.PUBLIC_URL}/categoria/0/error`}/>}
                </Route>
            </Switch>
            <Route>
                <ConfirmModal
                    confirmModal={props.confirmModal}
                    closeComfirmModal={props.closeConfirmModal}
                />
                <OrdineFormModal
                    closeOrderModal={props.closeOrderModal}
                    orderModal={props.orderModal}
                    liste={props.liste}
                    domicilio={props.domicilio}
                    config={props.config}
                    fasceOrarie={props.fasceOrarie}
                    orderConfirm={props.orderConfirm}
                    modalLoading={props.modalLoading}
                />
            </Route>
        </Router>
    </ErrorContext.Provider>
}

export default App;
